<script setup>
import { RouterLink, RouterView } from 'vue-router'
import { useAuthStore } from './stores/auth'
import { useNotificationsStore } from './stores/notifications'
import { onMounted, watch } from 'vue'
import MessageList from '@/components/MessageList.vue'
import AppFooter from './components/AppFooter.vue'

const authStore = useAuthStore()
const notificationsStore = useNotificationsStore()

onMounted(async () => {
  authStore.init()
})

watch(
  () => authStore.isAuthenticated,
  (isAuth) => {
    if (isAuth) {
      notificationsStore.fetch()
    }
  },
  { immediate: true }
)
</script>

<template>
  <MessageList />
  <header>
    <RouterLink to="/"> <img src="@/assets/project-icon.png" alt="Logo" /> </RouterLink>
    <h1>MIT Portfolio</h1>
    <nav>
      <RouterLink to="/" class="nav-messages">
        Home
        <span v-if="notificationsStore.count" class="badge">{{ notificationsStore.count }}</span>
      </RouterLink> | <RouterLink to="/projects">Projects</RouterLink> |
      <RouterLink to="/skills">Skills</RouterLink> |
      <RouterLink to="/enroll">Enroll</RouterLink> |
      <RouterLink to="/profile">Profile</RouterLink>
      <a v-if="authStore.isAdmin" href="/admin" class="admin-link">:Admin:</a>
    </nav>
  </header>

  <RouterView />
  <AppFooter />
</template>

<style lang="scss">
* {
  box-sizing: border-box;
}
body {
  margin: 0 14px;
}
main {
  padding-bottom: 3rem;  // Prostor pro fixed footer

  h2:first-child {
    text-align: center;
    color: $primari;
    font-size: 2rem;
  }
}
</style>

<style lang="scss" scoped>
header {
  display: flex;
}

h1 {
  margin: 0 2rem;
  font-variant: small-caps;
}

nav {
  font-size: 1.6em;
  margin-top: 10px;

  a {
    &:hover {
      color: white;
      background-color: $primari;
      box-shadow: 0px 0px 7px 7px $primari;
    }

    &.router-link-active {
      color: white;
      background-color: $primari;
      box-shadow: 0px 0px 7px 7px $primari;
      font-weight: bold;
    }
  }
}


.admin-link {
  margin-left: 2rem;
  color: $btnColor;
}

.nav-messages {
  position: relative;

  .badge {
    position: absolute;
    top: -8px;
    right: -12px;
    background: #e74c3c;
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 10px;
    min-width: 18px;
    text-align: center;
  }
}
</style>
